export default __webpack_public_path__ + "static/media/PulseHubUid.a4bdb268.png";